import { z } from "zod"

export const CreateWebExtractionSchema = z.object({
  url: z.url().max(4096),
  requestId: z.uuid(),
})

export const GetWebExtractionSchema = z.object({ id: z.string().regex(/^[a-f0-9]{64}$/) })
export const WebExtractionActorSchema = z.string().trim().min(1).max(200)
